import { BaseService } from '@estee/elc-service';
import { ServiceInitializer } from '@estee/elc-universal-utils';

const { name, version } = __serviceInfo__;

export class ApptBookingService extends BaseService {
    constructor(serviceInitializer: ServiceInitializer) {
        super(name, version, serviceInitializer);
    }
}

export default {
    apptBookingService: 'APPT_BOOKING_SERVICE',
    apptBookingLandingViewController: 'APPT_BOOKING_LANDING_VIEW_CONTROLLER',
    apptBookingApiSdk: 'APPT_BOOKING_API_SDK',
    httpTransport: 'HTTP_TRANSPORT',
    storeRepository: 'STORE_REPOSITORY',
    serviceRepository: 'SERVICE_REPOSITORY',
    categoryRepository: 'CATEGORY_REPOSITORY',
    configRepository: 'CONFIG_REPOSITORY',
    selectStoreViewController: 'SELECT_STORE_VIEW_CONTROLLER',
    selectServiceViewController: 'SELECT_SERVICE_VIEW_CONTROLLER',
    dayViewController: 'DAY_VIEW_CONTROLLER',
    selectDateTimeViewController: 'SELECT_DATE_TIME_VIEW_CONTROLLER',
    timeListViewController: 'TIME_LIST_VIEW_CONTROLLER',
    timeViewController: 'TIME_VIEW_CONTROLLER',
    reviewBookingViewController: 'REVIEW_BOOKING_VIEW_CONTROLLER',
    appointment: 'APPOINTMENT',
    businessUnitIdParser: 'BUSINESS_UNIT_ID_PARSER',
    priceFormatter: 'PRICE_FORMATTER',
    config: 'CONFIG',
    timeSlotRepository: 'TIME_SLOT_REPOSITORY',
    calendarEventRepository: 'CALENDAR_EVENT_REPOSITORY',
    appointmentRepository: 'APPOINTMENT_REPOSITORY',
    cancellationConfirmationViewController: 'CANCELATION_CONFIRMATION_VIEW_CONTROLLER',
    serviceBusController: 'SERVICE_BUS_CONTROLLER',
    confirmationContainerViewController: 'CONFIRMATION_CONTAINER_VIEW_CONTROLLER',
    reviewBookingContainerViewController: 'REVIEW_BOOKING_CONTAINER_VIEW_CONTROLLER',
    userDetailsRepository: 'USER_DETAILS_REPOSITORY',
    locationNameSort: 'LOCATION_NAME_SORT',
    formStoreRepository: 'FORM_STORY_REPOSITORY',
    legalContentRepository: 'LEGAL_CONTENT_REPOSITORY',
    legalOptionsViewController: 'LEGAL_OPTIONS_VIEW_CONTROLLER',
    defaultLegalOptionsViewController: 'DEFAULT_LEGAL_OPTIONS_VIEW_CONTROLLER',
    customLegalOptionsViewController: 'CUSTOM_LEGAL_OPTIONS_VIEW_CONTROLLER',
    accountSection: 'ACCOUNT_SECTION',
    accountSectionRepository: 'ACCOUNT_SECTION_REPOSITORY',
    userMarketingDetails: 'USER_MARKETING_DETAILS',
    userMarketingDetailsRepository: 'USER_MARKETING_DETAILS_REPOSITORY'
};
